module.exports = __webpack_public_path__ + "static/img/landing_api.2900bd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/landing_api.svg
// module id = BoYF
// module chunks = 1